export default __webpack_public_path__ + "static/media/name.e2e126cb.svg";